export const GET_DEPRECIATIONS = 'GET_DEPRECIATIONS';
export const SET_DEPRECIATIONS_PAGINATION = 'SET_DEPRECIATIONS_PAGINATION';
export const SET_DEPRECIATIONS_FILTERS = 'SET_DEPRECIATIONS_FILTERS';
export const RESET_DEPRECIATIONS = 'RESET_DEPRECIATIONS';
export const TOGGLE_DEPRECIATION = 'TOGGLE_DEPRECIATION';
export const ADD_DEPRECIATION = 'ADD_DEPRECIATION';
export const UPDATE_DEPRECIATION = 'UPDATE_DEPRECIATION';
export const GET_DEPRECIATION_BY_ID = 'GET_DEPRECIATION_BY_ID';
export const RESET_DEPRECIATION_FORM = 'RESET_DEPRECIATION_FORM';
export const GET_DEPRECIATION_FORM_CONFIG = 'GET_DEPRECIATION_FORM_CONFIG';
export const MODIFY_EDITING_DEPRECIATION = 'MODIFY_EDITING_DEPRECIATION';
export const ADD_YEAR_EDITING_DEPRECIATION = 'ADD_YEAR_EDITING_DEPRECIATION';
export const REMOVE_YEAR_EDITING_DEPRECIATION = 'REMOVE_YEAR_EDITING_DEPRECIATION';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION = 'MODIFY_CUSTOM_FIELD_EDITING_DEPRECATION';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/constants/depreciations_constants.js